import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * The one address shortener: `0x1234…abcd`.
 *
 * The separator is a real ellipsis (U+2026), not three ASCII dots — in a
 * monospace span three dots get spread across three full character cells and
 * read as a rendering glitch.
 */
export function shortenAddress(address: string): string {
    return `${address.slice(0, 6)}…${address.slice(-4)}`;
}
